import * as React from "react";
import {
  BarStyled,
  ButtonWrapper,
  Container,
  FormStyled,
} from "../../assets/styles/views/Steps";
import { Button } from "../../components/Button";
import Input from "../../components/Input";
import Select from "../../components/Select";
import { useNavigate } from "react-router-dom";
import { useInvoice } from "store/context";
import {
  resolvedStamp,
  resetLoadedStamp
} from 'store/actions'
import { toast, ToastContainer } from "react-toastify";
import { validateEmails } from "utils/validate";

//forma de pago SAT '99' (POR DEFINIR) no es valida para timbrar una factura
const UNDEFINED_PAYMENT_CODE = '99'

const StepTwo = () => {
  const navigate = useNavigate();
  const { state: { customer, loadStamp, origin }, dispatch } = useInvoice();
  const regimes = customer?.regimes;
  const uses = customer?.uses;
  const paymentTypes = customer?.paymentTypes?.filter(
    (paymentType) => paymentType?.code !== UNDEFINED_PAYMENT_CODE
  );

  const blank_regime = [{ code: '', description: 'Seleccionar un regimen' }]
  const blank_use = [{ code: '', description: 'Seleccionar un uso' }]
  const blank_payment = [{ code: '', description: 'Seleccionar una forma de pago' }]

  const valuesRegimes = blank_regime.concat(regimes || [])
  const valuesUses = blank_use.concat(uses || [])
  const valuesPayment = blank_payment.concat(paymentTypes || [])

  //form data
  const [rfc, setRfc] = React.useState(customer?.fiscalCustomer?.rfc || '');
  const [name, setName] = React.useState(customer?.fiscalCustomer?.name || '');
  const [address, setAddress] = React.useState(customer?.fiscalCustomer?.address || '');
  const [email, setEmail] = React.useState(customer?.fiscalCustomer?.email || '');
  const [use, setUse] = React.useState(customer?.fiscalCustomer?.purpose || '');
  const [regime, setRegime] = React.useState(customer?.fiscalCustomer?.regime || '');
  const [payment, setPayment] = React.useState(
    customer?.note?.paymentTypeCode === UNDEFINED_PAYMENT_CODE
      ? ''
      : customer?.note?.paymentTypeCode || ''
  );
  //captcha state
  const [validSubmit, setValidSubmit] = React.useState(false)

  //required fields
  const [requiredField, setRequiredField] = React.useState({
    rfc: '',
    name: '',
    address: '',
    email: '',
    regime: '',
    use: '',
    payment: '',
  });

  const handleStamp = async (event) => {
    event.preventDefault()
    let body = {};
    //validate emails
    const res = validateEmails(email);
    if (!rfc) {
      setRequiredField((prevState) => ({ ...prevState, rfc: 'error' }))
    }
    if (!name) {
      setRequiredField((prevState) => ({ ...prevState, name: 'error' }))
    }
    if (!address) {
      setRequiredField((prevState) => ({ ...prevState, address: 'error' }))
    }
    if (!regime) {
      setRequiredField((prevState) => ({ ...prevState, regime: 'error' }))
    }
    if (!use) {
      setRequiredField((prevState) => ({ ...prevState, use: 'error' }))
    }
    if (!payment) {
      setRequiredField((prevState) => ({ ...prevState, payment: 'error' }))
    }
    if (!email) {
      setRequiredField((prevState) => ({ ...prevState, email: 'error' }))
    }

    if (!res) {
      toast.error('El email no es valido', { theme: 'colored' })
      return
    }

    if (name && address && regime && use && payment && email) {
      body = {
        idNote: customer.note.id,
        paymentCode: payment,
        fiscalCustomer: {
          rfc: rfc,
          name: name,
          postal_code: address,
          email: email,
          sat_tax_regime_code: regime,
          sat_cfdi_use_code: use,
          paymentCode: payment
        },
        date: origin.date,
        invoiceKey: origin.invoiceKey,
        folio: origin.folio
      }
      setRequiredField('')
      await dispatch(resolvedStamp(dispatch, body))
    }
  }


  React.useEffect(() => {
    resetLoadedStamp(dispatch)
  }, [])
  React.useEffect(
    () => {
      if (loadStamp === 'resolved') {
        navigate('/archivos')
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadStamp]
  )

  return (
    <>
      <Container stepTwo>
        <FormStyled>
          <BarStyled />
          <Input
            requiredField={requiredField.rfc}
            placeholder="RFC"
            type="text"
            value={rfc}
            onChange={(e) => setRfc(e.target.value)}
            name="rfc"
          />
          <Input
            requiredField={requiredField.name}
            placeholder="Nombre"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            name="name"
          />
          <Input
            requiredField={requiredField.address}
            placeholder="Codigo Postal"
            type="text"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            name="address"
          />
          <Select
            onChange={(e) => setRegime(e.target.value)}
            name="regime"
            value={regime}
            requiredField={requiredField.regime}
          >
            {valuesRegimes?.map((use) => (
              <option key={use?.code} value={use?.code} >
                {use?.description}
              </option>
            ))}
          </Select>
          <Select
            onChange={(e) => setUse(e.target.value)}
            name="use"
            value={use}
            requiredField={requiredField.use}
          >
            {valuesUses?.map((use) => (
              <option key={use?.code} value={use?.code} >
                {use?.description}
              </option>
            ))}
          </Select>

          <Select
            onChange={(e) => setPayment(e.target.value)}
            name="payment"
            value={payment}
            requiredField={requiredField.payment}
            placeholder="Selccionar metodo de pago"
          >
            {valuesPayment?.map((payment) => (
              <option key={payment?.code} value={payment?.code} >
                {payment?.description}
              </option>
            ))}
          </Select>

          <Input
            requiredField={requiredField.email}
            placeholder="Email"
            type="email"
            value={email}
            name="email"
            onChange={(e) => setEmail(e.target.value)}
          />
          <ButtonWrapper>
            <Button onClick={handleStamp} disabled={loadStamp === 'pending' ? true : false}>FACTURAR</Button>
          </ButtonWrapper>
        </FormStyled>
      </Container>
      <ToastContainer autoClose={4000} />
    </>
  );
};

export default StepTwo;
